import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@pella/cosmos-react';
import { QUERY_KEYS } from '../../utils/enums';

/**
 * Hook to fetch sub-inventory locations for a given division.
 * @param {string} divId - The division ID to fetch locations for.
 * @returns {object} Division locations query result with data, loading, success, and error states.
 */
export const useDivisionLocations = (divId) => {
  const { api, apiReady } = useAPI();
  const { data, isLoading, isSuccess, isError, error } = useQuery({
    queryKey: [QUERY_KEYS.INV_MGMT_DIV_LOCATIONS, divId],
    queryFn: () => api.invMgmt.getSubInvLocations({ division: divId }),
    enabled: apiReady && Boolean(divId),
    staleTime: Number.POSITIVE_INFINITY,
  });
  return {
    divisionLocations: data,
    divisionLocationsIsLoading: isLoading,
    divisionLocationsIsSuccess: isSuccess,
    divisionLocationsIsError: isError,
    divisionLocationsError: error,
  };
};
